/**
 * 全局配置文件
 */
export default {
    title: "Macy Business System",
    logo: "Macys",
    indexTitle: 'Macys业务系统',
    lockPage: '/lock',
    tokenTime: 1700, //实际时间为token过期时间减去1分钟
    info: {
        title: "Macys业务系统",
        list: [
            'Macys业务系统'
        ]
    },
    //http的status默认放行不才用统一处理的,
    statusWhiteList: [400, 401],
    //配置首页不可关闭
    isFirstPage: false,
    fistPage: {
        label: "欢迎页",
        value: "/welcome",
        params: {},
        query: {},
        group: [],
        close: false,
		moduleId: '',
		code: 'SYS_WELCOME'
    },
    //配置菜单的属性
    menu: {
        props: {
            label: 'name',
            path: 'path',
            icon: 'icon',
            children: 'children'
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/website.js